import { Maybe } from '@oberoninternal/travelbase-ds/entities/Maybe';
import { isUpcoming, ticketsAvailable } from '../components/ActivityPlanner';
import sortBy from 'lodash/sortBy';
import { ActivityBookingTypesEnum } from '../generated/graphql';

export interface Timeslot {
    id: string;
    startDateTime: string;
    endDateTime: string;
    allotment?: Maybe<number>;
    rateGroup?: Maybe<{
        releaseHours?: Maybe<number> | undefined;
        rates: Array<{ id: string; name: string; price: number }>;
    }>;
}

const getBestRate = <T extends Timeslot>(timeslot: T): number =>
    Math.min(...(timeslot.rateGroup?.rates.map(rate => rate.price) ?? []));

const getBestTimeslot = <T extends Timeslot>(timeslots: T[], bookingType: ActivityBookingTypesEnum): T | null => {
    const bestTimeslot: T | null = sortBy(
        timeslots.filter(slot => isUpcoming(slot, true)),
        slot => getBestRate(slot),
        slot => (ticketsAvailable(slot, bookingType) ? 0 : 1)
    )[0];
    return bestTimeslot;
};

export default getBestTimeslot;
